// extracted by mini-css-extract-plugin
export default {"container":"SubPage_container__EhO78","back":"SubPage_back__2lHHO","content":"SubPage_content__lo4HG"};